module.exports = __webpack_public_path__ + "img/122.7e13edca.png";